// @flow
import * as React from 'react';


const Context: React.Context<Object> = React.createContext({
    reloadData: () => {},
    query: {
        offset: 0,
        limit: 25,
    },
});

export const withTable = (Wrapped: React.ComponentType<Object>) => {
    const WithTable = (props: Object) => (
        <Context.Consumer>
            {
                (value: Object) => (
                    <Wrapped {...props} table={value} />
                )
            }
        </Context.Consumer>
    );

    WithTable.displayName = `WithTable(${Wrapped.displayName || Wrapped.name || 'Component'})`;

    return WithTable;
};

export default Context;
